import { Link } from "react-router";
import { CATEGORY_LABELS, type Category } from "@abejon/shared";

interface BusinessCardProps {
  slug: string;
  displayName: string;
  category: string;
  avatarUrl: string | null;
  city: string | null;
  state: string | null;
  distance: number;
  bio: string | null;
}

export function BusinessCard({
  slug,
  displayName,
  category,
  avatarUrl,
  city,
  state,
  distance,
  bio,
}: BusinessCardProps) {
  return (
    <Link
      to={`/b/${slug}`}
      className="flex gap-4 rounded-lg border border-gray-200 p-4 transition-colors hover:bg-gray-50"
    >
      {/* Avatar */}
      <div className="h-14 w-14 flex-shrink-0 rounded-full bg-gray-300">
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={displayName}
            className="h-full w-full rounded-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center rounded-full bg-gray-900 text-lg font-bold text-white">
            {displayName.charAt(0).toUpperCase()}
          </div>
        )}
      </div>

      {/* Info */}
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between">
          <h3 className="text-sm font-semibold text-gray-900 truncate">{displayName}</h3>
          <span className="ml-2 flex-shrink-0 text-xs text-gray-500">
            {distance} mi
          </span>
        </div>
        <div className="mt-0.5 flex items-center gap-2 text-xs text-gray-500">
          <span className="rounded-full bg-gray-100 px-2 py-0.5 font-medium">
            {CATEGORY_LABELS[category as Category] ?? category}
          </span>
          {city && state && <span>{city}, {state}</span>}
        </div>
        {bio && (
          <p className="mt-1 text-xs text-gray-600 line-clamp-2">{bio}</p>
        )}
      </div>
    </Link>
  );
}
